module.exports = __webpack_public_path__ + "img/file.80febd14.png";